import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { UltraIcon } from '@pages/IntroducingBroker/assets/TierIcons'

import { Body1, Title1 } from '@ui/Typography'

import { useWindowResize } from '@utils/domUtils'

import { ConfettiIcon } from '../../assets/Confetti.icon'
import { MedalIcon } from '../../assets/Medal.icon'

import styles from './MaxLevelBanner.module.scss'

export const MaxLevelBanner: FC = () => {
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  return (
    <div className={styles.maxLevelBanner}>
      <ConfettiIcon className={styles.confetti} size={110} />
      <div className={styles.iconWrapper}>
        <UltraIcon className={styles.icon} size={56} />
      </div>
      <MedalIcon className={styles.medal} size={isMobile ? 56 : 69} />
      <div className={styles.textWrapper}>
        <Title1 className={styles.title}>{t('IB.Dashboard.Congratulations! 🎉')}</Title1>
        <Body1 className={styles.text}>{t('IB.Dashboard.You reached the maximum level')}</Body1>
      </div>
    </div>
  )
}
